import React from 'react';
import { connect } from 'react-redux';
import UpdateEmailConfirmation from './UpdateEmailConfirmation';
import TrainerChangeConfirmation from './TrainerChangeConfirmation';

const EventChangeManagement = ({
  updateEmailConfirmationVisible,
  trainerChangeConfirmationVisible,
}) => (
  <>
    {updateEmailConfirmationVisible && <UpdateEmailConfirmation />}
    {trainerChangeConfirmationVisible && <TrainerChangeConfirmation />}
  </>
);

const mapStateToProps = state => ({
  updateEmailConfirmationVisible:
    state.eventChangeManagement.updateEmail.confirmationVisible,
  trainerChangeConfirmationVisible:
    state.eventChangeManagement.trainerChange.confirmationVisible,
});

export default connect(mapStateToProps)(EventChangeManagement);
